export function regexQuote(str) {
	return (str + '').replace(/[.?*+^$[\]\\(){}|-]/g, '\\$&');
}
